import {Card, Separator} from 'platform/components';
import {Box, Center, HStack, VStack} from 'platform/foundation';

import {range} from 'ramda';

import {SkeletonLoadingBox} from '@dms/shared';

/*
  Heights are the real ones so the card does not resize under the data: the title is a
  Heading 4 line (24px), the subtitle Text small (20px), a column header is its padding plus
  an xSmall line (32px), and a body row is its cell padding plus the two-line trend cell,
  which is the tallest thing in it (64px).
*/
const TITLE_LINE = 6;
const SUBTITLE_LINE = 5;
const HEADER_ROW_HEIGHT = 8;
const BODY_ROW_HEIGHT = 16;
const FOOTNOTE_LINE = 4;
const PAGINATION_ROW_HEIGHT = 8;

const TITLE_SPACING = 1;
const CARD_SPACING = 4;

const TITLE_WIDTH = 40;
const SUBTITLE_WIDTH = 60;
const FOOTNOTE_WIDTH = 90;
const PAGINATION_WIDTH = 40;

const RANK_WIDTH = 4;
const AVATAR_SIZE = 7;
const NAME_WIDTH = 36;
const CELL_WIDTH = 18;
const CELL_LINE = 4;

/** Enough rows to fill the card without pretending to know how long the board is. */
const SKELETON_ROW_COUNT = 6;
const SKELETON_CELL_COUNT = 4;

export function SalesLeagueTableSkeleton() {
  return (
    <Card>
      <VStack spacing={CARD_SPACING}>
        <VStack spacing={TITLE_SPACING}>
          <SkeletonLoadingBox isLoading width={TITLE_WIDTH} height={TITLE_LINE} />
          <SkeletonLoadingBox isLoading width={SUBTITLE_WIDTH} height={SUBTITLE_LINE} />
        </VStack>

        <VStack spacing={0}>
          <Box height={HEADER_ROW_HEIGHT} backgroundColor="palettes.neutral.10.100" />
          {range(0, SKELETON_ROW_COUNT).map((row) => (
            <Box key={row} height={BODY_ROW_HEIGHT}>
              <Center height="100%">
                <HStack spacing={4} align="center" width="100%">
                  <SkeletonLoadingBox isLoading width={RANK_WIDTH} height={CELL_LINE} />
                  <SkeletonLoadingBox
                    isLoading
                    width={AVATAR_SIZE}
                    height={AVATAR_SIZE}
                    borderRadius="circular"
                  />
                  <SkeletonLoadingBox isLoading width={NAME_WIDTH} height={CELL_LINE} />
                  {range(0, SKELETON_CELL_COUNT).map((cell) => (
                    <Box key={cell} flex={1}>
                      <SkeletonLoadingBox isLoading width={CELL_WIDTH} height={CELL_LINE} />
                    </Box>
                  ))}
                </HStack>
              </Center>
            </Box>
          ))}
        </VStack>

        <SkeletonLoadingBox isLoading width={FOOTNOTE_WIDTH} height={FOOTNOTE_LINE} />

        <Separator spacing={0} />

        <Box height={PAGINATION_ROW_HEIGHT}>
          <Center height="100%">
            <HStack justify="space-between" width="100%">
              <SkeletonLoadingBox isLoading width={PAGINATION_WIDTH} height={CELL_LINE} />
            </HStack>
          </Center>
        </Box>
      </VStack>
    </Card>
  );
}
